export default function Hero() {
  const handleScrollTo = (href: string) => {
    const target = document.querySelector(href);
    if (target) target.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://public.readdy.ai/ai/img_res/1a0eded88d73b202bac729dc37c377c8.jpg"
          alt="Central de Monitoramento RE_CONECTA"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-neutral-950/98 via-neutral-950/85 to-neutral-950/50"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-neutral-950/70 via-transparent to-neutral-950/40"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 py-36">
        <div className="max-w-2xl">
          {/* Badge */}
          <div className="inline-flex items-center gap-2.5 border border-red-500/50 bg-red-500/10 backdrop-blur-sm rounded-full px-4 py-2 mb-8">
            <span className="w-2 h-2 rounded-full bg-red-500 animate-pulse flex-shrink-0"></span>
            <span className="text-red-400 text-sm font-medium">Tecnologia em Segurança Eletrônica</span>
          </div>

          {/* Title */}
          <h1 className="text-5xl lg:text-6xl font-bold text-white leading-tight mb-6 drop-shadow-lg" style={{ fontFamily: 'Poppins, sans-serif' }}>
            Simplificamos o<br />
            <span className="text-red-500">Complexo</span> em<br />
            Segurança Crítica
          </h1>

          {/* Subtitle */}
          <div className="mb-10 max-w-xl">
            <p className="text-neutral-800 text-lg leading-relaxed bg-white/70 backdrop-blur-sm rounded-lg px-4 py-3">
              Com vasta experiência em implantação e manutenção de sistemas críticos de segurança e monitoramento, atendemos clientes de renome nacional com agilidade e rigor técnico.
            </p>
          </div>

          {/* CTAs */}
          <div className="flex flex-wrap gap-4 mb-16">
            <button
              onClick={() => handleScrollTo('#services')}
              className="bg-red-600 hover:bg-red-700 text-white px-8 py-3.5 rounded-lg font-semibold text-sm flex items-center gap-2 transition-colors cursor-pointer whitespace-nowrap"
            >
              Conheça Nossas Soluções
              <i className="ri-arrow-right-line"></i>
            </button>
            <button
              onClick={() => handleScrollTo('#contact')}
              className="border border-white/40 hover:border-white/70 hover:bg-white/10 text-white px-8 py-3.5 rounded-lg font-semibold text-sm flex items-center gap-2 transition-all cursor-pointer whitespace-nowrap backdrop-blur-sm"
            >
              <i className="ri-phone-line"></i>
              Falar com Especialista
            </button>
          </div>

          {/* Stats */}
          <div className="flex items-center gap-8">
            <div>
              <p className="text-3xl font-bold text-white" style={{ fontFamily: 'Poppins, sans-serif' }}>11+</p>
              <p className="text-neutral-400 text-xs mt-1 uppercase tracking-wide">Clientes Parceiros</p>
            </div>
            <div className="w-px h-10 bg-white/20"></div>
            <div>
              <p className="text-3xl font-bold text-white" style={{ fontFamily: 'Poppins, sans-serif' }}>24/7</p>
              <p className="text-neutral-400 text-xs mt-1 uppercase tracking-wide">Suporte Técnico</p>
            </div>
            <div className="w-px h-10 bg-white/20"></div>
            <div>
              <p className="text-3xl font-bold text-white" style={{ fontFamily: 'Poppins, sans-serif' }}>100%</p>
              <p className="text-neutral-400 text-xs mt-1 uppercase tracking-wide">Foco em Resultados</p>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 text-white/50">
        <span className="text-xs uppercase tracking-widest font-medium">Scroll</span>
        <div className="w-5 h-5 flex items-center justify-center">
          <i className="ri-arrow-down-line animate-bounce text-lg"></i>
        </div>
      </div>
    </section>
  );
}
